import React from "react";
import { Show } from "@refinedev/antd";
import { Descriptions, Skeleton } from "antd";
import type { FieldDef } from "@evo-flywheel/contracts";
import { useResource, useShow } from "@refinedev/core";
import { resourceBySlug } from "../kit-resources";
import { renderCell } from "../fields";
import { Deadlines, Lifecycle, MarkdownView, uiOf } from "../modules/hints";
import { ObligationsCard } from "../modules/obligations";
import { ShowSlots, useRelatedRecords } from "@evo-flywheel/ui";

/** Generated Show: lifecycle + deadlines header, fields (Markdown bodies rendered), the module's own
 * panels and the record's open obligations; related records and links fill the layout's right column. */
export const GenericShow: React.FC = () => {
  const { resource } = useResource();
  const slug = resource?.name;
  const meta = resourceBySlug[slug ?? ""]?.meta;
  const { queryResult } = useShow();
  const record = queryResult.data?.data as Record<string, unknown> | undefined;
  const fields = new Map<string, FieldDef>((meta?.fields ?? []).map((field) => [field.name, field]));
  const labelOf = (name: string) => fields.get(name)?.label ?? name;
  const view = meta?.showView ?? [];
  // Markdown bodies render below the fields even when coreBOS's show view does not list them
  const bodies = uiOf(slug).markdown ?? [];
  useRelatedRecords(slug, record, String(record?.[view[0] ?? ""] ?? record?.id ?? ""));
  return <Show isLoading={queryResult.isLoading}>{!record ? <Skeleton active /> : <>
    <Lifecycle slug={slug} record={record} />
    <Deadlines slug={slug} record={record} labelOf={labelOf} />
    <Descriptions bordered column={1} size="small">
      {view.filter((name) => !bodies.includes(name)).map((name) => <Descriptions.Item key={name} label={labelOf(name)}>{renderCell(fields.get(name), record[name], slug)}</Descriptions.Item>)}
    </Descriptions>
    {bodies.map((name) => record[name] ? <div key={name} style={{ marginTop: 16 }}><MarkdownView value={record[name]} /></div> : null)}

    <div style={{ marginTop: 16 }}><ShowSlots slug={slug} record={record} /></div>
    <ObligationsCard slug={slug} record={record} />
  </>}</Show>;
};
